import ApiCallback, {API_CALLBACK_SEND_RATE} from "~/chat/ts/service/api/methods/ApiCallback";
import {ChatTabStore} from "~/chat/ts/store/ChatTab";
import {ConfigStore} from "~/chat/ts/store/Config";
import {WidgetStore} from "~/chat/ts/store/Widget";
import {computed} from "vue";

export function useRateRequest() {
    let system = computed(() => {
        return ConfigStore.siteParams.value.params.rate.values;
    });

    function onInput(value: string) {
        WidgetStore.openSendReview({value});
    }

    function hide() {
        ChatTabStore.CANCEL_RATE_REQUEST();
    }

    return {
        system,
        onInput,
        hide
    };
}

ApiCallback.setCallback(API_CALLBACK_SEND_RATE, () => {
    ChatTabStore.CANCEL_RATE_REQUEST(false);
});
